import { css } from '@emotion/react';

import Button from 'components/field/Button';

import useAlert from 'hooks/useAlert';

import { faFileArrowDown } from '@fortawesome/pro-solid-svg-icons';

const InvoiceLink = ({ data }) => {
	const { showError } = useAlert();

	const handleClick = () => {
		if (data.invoiceLink) {
			const link = document.createElement('a');
			link.setAttribute('download', `${'Invoice'}-${data.ID}.pdf`);
			link.href = data.invoiceLink;
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);
		} else {
			showError({
				title: 'Error',
				message: 'errorMsg.invoiceLink'
			});
		}
	};

	return (
		<>
			{data.invoiceLink && (
				<Button
					label="download"
					variant={'blueBorderless'}
					disabled={!data.invoiceLink}
					disabledTooltip="errorMsg.invoiceLink"
					icon={faFileArrowDown}
					fullWidth
					css={css`
						margin: auto;
						gap: 1rem;
						> .typography,
						> .icon {
							font-size: var(--paragraph3-font-size) !important;
						}

						:hover {
							background-color: var(--blue-10) !important;
						}
					`}
					onClick={handleClick}
				/>
			)}
		</>
	);
};

export default InvoiceLink;
